import {api} from "./axios";

export const getAdminBookings = () =>
  api.get("/admin/bookings");

export const updateBookingStatus = (id, status) =>
  api.put(`/admin/bookings/${id}/status`, { status });